import DefaultList from "@/components/DefaultList";
import AgreementTypeCreator from "@/modules/agreement-types/components/AgreementTypeCreator";
import AgreementTypeEditor from "@/modules/agreement-types/components/AgreementTypeEditor";
import { PATH_DICTS_AGREEMENT_TYPES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import {
  agreementTypeRead,
  agreementTypeCreate,
} from "@/schemas/agreementType";
import { AgreementTypeService } from "@/services/agreementType";
import { AgreementType, AgreementTypeCreate } from "@/types/agreementType";
import { FileText } from "lucide-react";

const id = Module.AgreementTypes;
const path = PATH_DICTS_AGREEMENT_TYPES;
const ns = "agreementTypes";

const config: DictionaryConfig<AgreementType, AgreementTypeCreate> = {
  id,
  ns,
  service: AgreementTypeService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: agreementTypeCreate,
  defaultValues: {
    name: "",
    valid_from: "",
    valid_to: "",
    company_id: "",
    template_code: "",
    active: true,
    sort_order: 0,
    contest_regulations_required: true,
    is_b2b: false,
  },
  excludeFromDefaultMenu: true,
  Icon: FileText,
  List: () => (
    <DefaultList<AgreementType>
      schema={agreementTypeRead}
      name={ns}
      fetchList={AgreementTypeService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.AgreementTypes },
      }}
    />
  ),
  Creator: AgreementTypeCreator,
  Editor: AgreementTypeEditor,
};

export default config;
